import { Input } from './input';
import { IUIElementOptions, IKeyValue, INumberInputOptions } from '../../../interfaces';
import { Templates } from '../../../compile';
import * as Globalize from '@mapp/globalize';
import * as _ from 'underscore';
import { Util } from '../..';
import { ApplicationConfig } from '../../../const';

export class NumberInput extends Input<number> {
	private numberDisplayValue: KnockoutComputed<string>;
	private currentInput: KnockoutObservable<any>;
	private groupingRegExp: KnockoutObservable<RegExp>;
	private numberValue: KnockoutObservable<number>;
	private element: KnockoutObservable<Element>;

	constructor(
		id: string,
		label: string,
		value: number | KnockoutObservable<number>,
		options?: INumberInputOptions
	) {
		options = $.extend(
			true,
			{},
			<INumberInputOptions>{
				widget: {
					widget: Templates.widgets_numberInput
				},
				grouping: true
			},
			options || {}
		);

		var validationObservable = ko.observable<number>();
		if (ko.isObservable(value)) {
			validationObservable(value());
			Util.cloneRules(value, validationObservable);
		} else {
			validationObservable(value);
		}

		let groupingRegExp = ko.observable<RegExp>();
		validationObservable.extend({
			isValidNumber: {
				groupingRegExp: groupingRegExp
			},
			greaterThanMaxNumber: {
				groupingRegExp: groupingRegExp
			},
			lessThanMinNumber: {
				groupingRegExp: groupingRegExp
			}
		});

		super(id, label, validationObservable, options);

		if (ko.isObservable(value)) {
			value.isValid = validationObservable.isValid;
			value.rules = validationObservable.rules;
		}

		this.groupingRegExp = groupingRegExp;
		this.refreshGroupingExp();

		ApplicationConfig.language.subscribe(() => this.refreshGroupingExp());

		//same as this.value but type of KnockoutObservable<any> instead of <number> to ensure string handling,
		//because knockoutjs is not typesafe
		this.currentInput = validationObservable;

		this.numberValue = ko.isObservable(value) ? value : ko.observable(value);
		//TODO: remove event listener when dom is not visible
		this.element = ko.observable<Element>();

		this.element.subscribe((element: Element) => {
			if (element) {
				element.addEventListener('copy', (e: ClipboardEvent) => {
					// if (e && e.srcElement && e.srcElement.id == this.id) { <-- TS2339: Property 'id' does not exist on type 'EventTarget'.
					if (e && e.srcElement && e.srcElement['id'] == this.id) {
						let _value = this.numberValue();
						let clipboardValue =
							_value != null && _value != undefined && !isNaN(_value)
								? _value.toString()
								: this.currentInput();
						e.clipboardData.setData('text/plain', clipboardValue);
						e.preventDefault();
					}
				});
			}
		}, 'change');

		this.numberDisplayValue = ko.computed<string>({
			read: () => {
				let value = this.numberValue();
				if (isNaN(value)) {
					return this.currentInput();
				} else if (_.isUndefined(value) || _.isNull(value)) {
					this.currentInput(null);
					return this.currentInput();
				}

				let lastRead = Globalize.formatNumber(value, {
					maximumFractionDigits: 10,
					minimumFractionDigits: 0,
					useGrouping: options.grouping
				});
				this.currentInput(lastRead);
				return lastRead;
			},
			write: (value: string) => {
				let parsedString = value.replace(this.groupingRegExp(), '');
				let parsedNumber = Globalize.parseNumber(parsedString);
				if (
					!isNaN(parsedNumber) &&
					parsedNumber < Number.MAX_SAFE_INTEGER &&
					parsedNumber > Number.MIN_SAFE_INTEGER
				) {
					this.numberValue(parsedNumber);
					this.currentInput(parsedString);
				} else {
					this.numberValue(NaN);
					this.currentInput(value);
				}
			}
		});
	}

	//Override
	public serialize(serializeObject: IKeyValue<any>): IKeyValue<any> {
		serializeObject[this.id] = this.numberValue();
		return serializeObject;
	}

	private refreshGroupingExp(): void {
		let defaultNumberingSystem: string = Globalize.cldr.main('numbers/defaultNumberingSystem');
		let groupingSymbol = Globalize.cldr.main(
			`numbers/symbols-numberSystem-${defaultNumberingSystem}/group`
		);

		let groupingRegExp = new RegExp(`[${groupingSymbol}]`, 'g');

		this.groupingRegExp(groupingRegExp);
	}
}
